import { render } from "./EllipseView.vue?vue&type=template&id=2bd8f989"
import script from "./EllipseView.vue?vue&type=script&lang=js"
export * from "./EllipseView.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__